import '../css/reset.css';
import '../css/bmfont.css';
import '../css/common.css';
import '../css/business.css';
import 'lazysizes';
import {
  OLD_API_URL,
  requestGET,
  numberWithCommas,
  getInfoOfDeviceOS,
} from './common-es6';

const eapCalculate = document.getElementById('eapCalculate');
const eapTotalEmployees = document.getElementById('eapTotalEmployees');
const eapNeedsMentalCare = document.getElementById('eapNeedsMentalCare');
const eapLossTime = document.getElementById('eapLossTime');
const eapLossCost = document.getElementById('eapLossCost');
const eapTotalPeopleCount = document.getElementById('eapTotalPeopleCount');
const eapUsePeopleCount = document.getElementById('eapUsePeopleCount');
const otherEapTotalPayment = document.getElementById('otherEapTotalPayment');
const trostEapTotalPayment = document.getElementById('trostEapTotalPayment');
const otherEapComparison = document.getElementById('otherEapComparison');
const trostEapComparison = document.getElementById('trostEapComparison');
const otherEapTotalPaymentMobile = document.getElementById('otherEapTotalPaymentMobile');
const trostEapTotalPaymentMobile = document.getElementById('trostEapTotalPaymentMobile');
const otherEapComparisonMobile = document.getElementById('otherEapComparisonMobile');
const trostEapComparisonMobile = document.getElementById('trostEapComparisonMobile');
const trostBusinessPartnerList = document.getElementById('trostBusinessPartnerList');

const trostEAPPriceTable = document.getElementsByClassName('trost-eap-price__table display-only-pc')[0];
const smallAmountTitle = document.getElementsByClassName('small-amount__title')[0];
const smallAmountContent = document.getElementsByClassName('small-amount__content')[0];
const trostEAPPriceTableMobileField = document.getElementsByClassName('trost-eap-price__table--mobile-field')[0];
const trostEAPSmallAmountTableMobileField = document.getElementsByClassName('trost-eap-mini-price__table--mobile')[0];

const tdList = document.getElementsByTagName('td');

const deviceOS = getInfoOfDeviceOS();

const eapCalculateData = [10, 20, 30, 40, 50, 60, 70, 80, 90, 100, 200, 300, 400, 500, 600, 700, 800, 900, 1000, 2000, 3000, 4000, 5000, 6000, 7000, 8000, 9000, 10000];
const trostPartnerList = [
  {
    groupCode: 'NHN',
    imageUrl: 'https://assets.trost.co.kr/images/service/main/img_logo_partners_1.png',
  },
  {
    groupCode: 'GKL 그랜드코리아레저',
    imageUrl: 'https://assets.trost.co.kr/images/service/main/img_logo_partners_2.png',
  },
  {
    groupCode: '한국폴리텍대학',
    imageUrl: 'https://assets.trost.co.kr/images/service/main/img_logo_partners_3.png',
  },
  {
    groupCode: 'fastfive',
    imageUrl: 'https://assets.trost.co.kr/images/service/main/img_logo_partners_4.png',
  },
  {
    groupCode: 'wework',
    imageUrl: 'https://assets.trost.co.kr/images/service/main/img_logo_partners_5.png',
  },
];

const businessData = {
  bulkPurchase: {
    texttime: {
      name: '텍스트테라피',
      payment: 50000,
      discountNum: [2, 5, 12],
      counselingCount: [30, 50, 100],
      counselingTime: [50, 50, 50],
    },
    voicetime: {
      name: '전화상담',
      payment: 65000,
      discountNum: [2, 5, 12],
      counselingCount: [30, 50, 100],
      counselingTime: [50, 50, 50],
    },
  },
  eapProgram: {
    mixed: ['texttime', 'voicetime'],
    name: ['텍스트테라피', '전화상담'],
    payment: 50000,
    discountNum: [5, 15],
    counselingCount: [2, 4],
    counselingTime: [50, 50],
  },
};

const createEAPTablePC = () => {
  const {
    bulkPurchase,
    eapProgram,
  } = businessData;
  const tableList = Object.keys(bulkPurchase);
  const dataValueList = Object.values(bulkPurchase);

  let bulkPurchaseCounselingTypeList = '<td></td>';
  let bulkPurchasePayment = '';
  let eapProgramTitleList = '';
  let eapProgramContentList = '';

  for (let i = 0, len = tableList.length; i < len; i += 1) {
    const {
      name,
    } = bulkPurchase[tableList[i]];

    bulkPurchaseCounselingTypeList += `
      <td>
          <div class="counseling-type__field">
              <img src="https://assets.trost.co.kr/images/service/partner/ic-${tableList[i]}.png" alt="${name} 아이콘" class="counseling-type__icon">
              <span class="counseling-type__text">${name}</span>
          </div>
      </td>`;
  }

  for (let i = 0, len = bulkPurchase[tableList[0]].discountNum.length; i < len; i += 1) {
    const {
      discountNum,
      counselingCount,
    } = dataValueList[0];

    bulkPurchasePayment += `
      <tr class="eap-price__count">
          <td>
              <div class="eap-price-discount__field">
                  <span class="eap-price__discount">${discountNum[i]}% 할인</span>
                  <img src="https://assets.trost.co.kr/images/service/main/ic-discount.png" alt="eap 구매 할인 아이콘" class="eap-price-discount__icon">
              </div>
              <span class="eap-price__counseling-count">${counselingCount[i]}장</span>
          </td>`;

    for (let j = 0, len2 = dataValueList.length; j < len2; j += 1) {
      const {
        payment,
        counselingTime,
      } = dataValueList[j];
      const priceItem = payment * (1 - (discountNum[i] / 100));

      bulkPurchasePayment += `
        <td class="">
            <span class="eap-price__minutes">1회 (${counselingTime[i]}분)</span>
            <span class="eap-price__price">${numberWithCommas(priceItem)}원</span>
            <span class="eap-price__total-price">(총 ${numberWithCommas(priceItem * counselingCount[i])}원)</span>
        </td>`;
    }

    bulkPurchasePayment += '</tr>';
  }

  for (let i = 0, len = eapProgram.mixed.length; i < len; i += 1) {
    const {
      payment,
      discountNum,
      counselingCount,
      counselingTime,
    } = eapProgram;
    const priceItem = payment * (1 - (discountNum[i] / 100));

    eapProgramTitleList += `<td class="">${counselingCount[i]}회</td>`;

    eapProgramContentList += `
      <td class="">
          <div class="small-amount-discount-percentage__field">
              <span class="small-amount-discount-percentage">${discountNum[i]}% 할인</span>
              <img src="https://assets.trost.co.kr/images/service/main/ic-discount.png" alt="eap 구매 할인 아이콘" class="eap-price-discount__icon">
          </div>
          <span class="small-amount-price">1인 (${counselingTime[i]}분 x ${counselingCount[i]}회)<br><b>${numberWithCommas(priceItem)}원 부터</b></span>
          <span class="small-amount-one-time-price">(1회당 ${numberWithCommas(priceItem / 2)}원 부터)</span>
      </td>`;
  }

  const bulkPurchaseCounselingType = `<tr class="eap-price__counseling-type">${bulkPurchaseCounselingTypeList}</tr>`;
  const eapProgramTitle = `<tr class="small-amount__title">${eapProgramTitleList}<td class="">맞춤형 패키지</td></tr>`;
  const eapProgramContent = `<tr class="small-amount__content">${eapProgramContentList}<td class=""><span class="small-amount-custom-package">인원수 및 횟수에 따라<br><b>가격 합의 가능</b></span></td></tr>`;

  trostEAPPriceTable.innerHTML = `${bulkPurchaseCounselingType}${bulkPurchasePayment}`;

  smallAmountTitle.innerHTML = eapProgramTitle;
  smallAmountContent.innerHTML = eapProgramContent;
};

const createEAPTableMobile = () => {
  const {
    bulkPurchase,
    eapProgram,
  } = businessData;
  const tableList = Object.keys(bulkPurchase);

  let eapTableList = '';
  let eapSmallAmountTableList = '';

  for (let i = 0, len = tableList.length; i < len; i += 1) {
    const {
      name,
      payment,
      discountNum,
      counselingCount,
      counselingTime,
    } = bulkPurchase[tableList[i]];

    eapTableList += `
      <table class="trost-eap-price__table--mobile display-only-mobile">
        <tbody>
          <tr class="eap-price__counseling-type">
              <td class="" colspan="2">
                  <div class="counseling-type__field">
                      <img src="https://assets.trost.co.kr/images/service/partner/ic-${tableList[i]}.png" alt="${name} 아이콘" class="counseling-type__icon">
                      <span class="counseling-type__text">${name}</span>
                  </div>
              </td>
          </tr>`;

    for (let j = 0, len2 = discountNum.length; j < len2; j += 1) {
      const priceItem = payment * (1 - (discountNum[j] / 100));

      eapTableList += `        
        <tr class="eap-price__count">
            <td class="">
                <div class="eap-price-discount__field">
                    <span class="eap-price__discount">${discountNum[j]}% 할인</span>
                    <img src="https://assets.trost.co.kr/images/service/main/ic-discount.png" alt="eap 구매 할인 아이콘" class="eap-price-discount__icon">
                </div>
                <span class="eap-price__counseling-count">${counselingCount[j]}장</span>
            </td>
            <td class="">
                <div class="eap-price__payment-field">
                    <span class="">1회 (${counselingTime[j]}분)</span><br>
                    <span class=""><b>${numberWithCommas(priceItem)}원</b></span><br>
                    <span class="">(총 ${numberWithCommas(priceItem * counselingCount[j])}원)</span><br>
                </div>
            </td>
        </tr>`;
    }

    eapTableList += '</tbody></table>';
  }

  for (let i = 0, len = eapProgram.mixed.length; i < len; i += 1) {
    const {
      payment,
      discountNum,
      counselingCount,
      counselingTime,
    } = eapProgram;
    const priceItem = payment * (1 - (discountNum[i] / 100));

    eapSmallAmountTableList += `
      <tr class="eap-price__count">
          <td class="">
              <div class="eap-price-discount__field">
                  <span class="eap-price__discount">${discountNum[i]}% 할인</span>
                  <img src="https://assets.trost.co.kr/images/service/main/ic-discount.png" alt="eap 구매 할인 아이콘" class="eap-price-discount__icon">
              </div>
              <span class="eap-price__counseling-count">${counselingCount[i]}회</span>
          </td>
          <td class="">
              <div class="eap-price__payment-field">
                  <span class="">1인 (${counselingTime[i]}분 x ${counselingCount[i]}회)</span><br>
                  <span class=""><b>${numberWithCommas(priceItem)}원 부터</b></span><br>
                  <span class="">(총 ${numberWithCommas(priceItem * counselingCount[i])}원)</span><br>
              </div>
          </td>
      </tr>`;
  }

  const eapSmallAmountTable = `
    ${eapSmallAmountTableList}
    <tr class="eap-price__count">
        <td class="">
            <span class="eap-price__counseling-count">맞춤형<br>패키지</span>
        </td>
        <td class="">
            <div class="eap-price__payment-field">
                <span class="">인원수 및 횟수에 따라</span><br>
                <span class=""><b>가격 합의 가능</b></span>
            </div>
        </td>
    </tr>`;

  trostEAPPriceTableMobileField.innerHTML = eapTableList;
  trostEAPSmallAmountTableMobileField.innerHTML += eapSmallAmountTable;
};

const createEAPList = () => {
  requestGET(`${OLD_API_URL}/company/`, (status, resData) => {
    if (!status || !resData.result) {
      return false;
    }

    const {
      data,
    } = resData;
    const eapListData = [...data, ...trostPartnerList];
    let eapListText = '';

    for (let i = 0, len = eapListData.length; i < len; i += 1) {
      const {
        imageUrl,
        groupCode,
      } = eapListData[i];

      eapListText += `<div class="eap-list-img__field"><img class="eap-list__img lazyload" data-src="${imageUrl}" alt="eap-${groupCode}"></div>`;
    }

    trostBusinessPartnerList.innerHTML = eapListText;

    return true;
  });
};

eapCalculate.addEventListener('input', () => {
  const { value } = eapCalculate;
  const percentage = (100 / 27) * value;
  const eapUsePeopleCountNum = eapCalculateData[value] * 0.03;
  const peopleCount = eapUsePeopleCountNum < 1 ? 1 : Math.round(eapUsePeopleCountNum);
  console.log(value);
  console.log(eapCalculateData[value]);

  eapTotalEmployees.textContent = `${numberWithCommas(eapCalculateData[value])} 명`;
  eapNeedsMentalCare.textContent = `${numberWithCommas(eapCalculateData[value] * 0.2)} 명`;
  eapLossTime.textContent = `${numberWithCommas(eapCalculateData[value] * 63.6)} 시간`;
  eapLossCost.textContent = `${numberWithCommas(eapCalculateData[value] * 1896440)} 원`;

  eapTotalPeopleCount.textContent = `정서 관리가 필요한 ${numberWithCommas(eapCalculateData[value] * 0.2)}명`;
  eapUsePeopleCount.textContent = `${peopleCount}명이 상담 서비스를 이용`;

  if (deviceOS === 'web') {
    otherEapTotalPayment.textContent = `${numberWithCommas(peopleCount * 80000 * 8)}원`;
    trostEapTotalPayment.textContent = `${numberWithCommas(peopleCount * 50000 * 4)}원`;

    otherEapComparison.textContent = `${peopleCount}명`;
    trostEapComparison.textContent = `${peopleCount}명`;
  } else {
    otherEapTotalPaymentMobile.textContent = `${numberWithCommas(peopleCount * 80000 * 8)}원`;
    trostEapTotalPaymentMobile.textContent = `${numberWithCommas(peopleCount * 50000 * 4)}원`;

    otherEapComparisonMobile.textContent = `${peopleCount}명`;
    trostEapComparisonMobile.textContent = `${peopleCount}명`;
  }

  eapCalculate.style.background = `linear-gradient(to right, #fbb300 0%, #f57c00 ${percentage}%, #f2f2f2 ${percentage}%, #f2f2f2 100%)`;
});

window.addEventListener('DOMContentLoaded', () => {
  if (deviceOS === 'web') {
    createEAPTablePC();
  } else {
    createEAPTableMobile();
  }

  createEAPList();

  if (deviceOS !== 'web') {
    for (let i = 0, len = tdList.length; i < len; i += 1) {
      tdList[i].style.minWidth = `${(window.screen.width / 2) - 24}px`;
    }
  }
});
